import React = require('react');
import * as ReactDOM from "react-dom";
import CropImageUploader from './CropImageUploader';
import { IprofileCanvas } from '../../interfaces/layout/blocks/IUser';

declare var window:any;

interface IEditItemCompImageProps {
    id:number
    image:string
}

interface IEditItemCompImageState {
    profileCanvas:IprofileCanvas
    image:string
}

export default class EditItemCompImage extends React.Component<IEditItemCompImageProps, IEditItemCompImageState>{

    constructor(props:IEditItemCompImageProps){
        super(props);
        this.state = {
            profileCanvas:{
				x: 0,
				y: 0,
				scale: 1
			},
            image: this.props.image
        };
        window.editItemImage = {
            removeImage: false,
            image: this.state.image
        };
    }

    protected canvasChangedHandler(positions:any): void {
        if ( this.state.profileCanvas !== positions) {
            this.setState({
                profileCanvas: positions
            } as IEditItemCompImageState);
        }
	}

    protected setFile(file):void{
		var removeImage:boolean = false;
		if ( file === null ) {
			removeImage = true;
		}
        window.editItemImage.image = file;
        window.editItemImage.removeImage = removeImage;

        this.setState({
             image: file
        } as IEditItemCompImageState);

    }

    render() {
        var profileUrl:string = '/profilok/'+this.props.id;
        return (
            <div>
                <CropImageUploader
                    x={ this.state.profileCanvas.x }
                    y={ this.state.profileCanvas.y }
                    scale={ this.state.profileCanvas.scale }
                    file={ this.state.image }
                    setFile={ file => this.setFile(file) }
                    refreshCanvas={ positions => this.canvasChangedHandler(positions) }
                    uploadButtonName= "Feltöltés"
                    removeLabel="KÉP TÖRLÉSE"
                />
            </div>
        );
    }
}

export class ReInitEditItemCompImage {
    constructor( id:number, image:string ) {
        var div: HTMLDivElement = document.getElementById('editor_item_comp_image') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.unmountComponentAtNode(div);
            ReactDOM.render(<EditItemCompImage id={ id } image={ image } />, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/EditItemCompImage.tsx